import { render, staticRenderFns } from "./QuestionId.vue?vue&type=template&id=0aade6aa"
import script from "./QuestionId.vue?vue&type=script&lang=js"
export * from "./QuestionId.vue?vue&type=script&lang=js"
import style0 from "./QuestionId.vue?vue&type=style&index=0&id=0aade6aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports